import { Box, Divider, Typography } from '@mui/material';
import PageHeader from 'components/Header/Page';
import React, { useEffect, useState } from 'react';
import LoaderComponent from 'components/Loader';
import { addOrUpdateInsights, deleteInsights, getInsights } from 'service/service';
import moment from 'moment';
import Insights from 'components/DataEstate/Insights';
import YearMonthPicker from 'components/Dropdown/YearMonthPicker';

const MBTDashboard = () => {
    const isXOps = true;
    const getInitialMonth = () => {
            return isXOps ? moment().subtract(1, 'month').format('YYYY-MM') : '0M';
          };
    const [customMonth, setCustomMonth] = useState(getInitialMonth());
    const [filterMonth, setFilterMonth] = useState(getInitialMonth());
    const [insights, setInsights] = useState<Insights[]>([]);
    const [loader, setLoader] = useState<boolean>(false);
    interface Insights {
        insightId: number;
        title: string;
        description: string;
        opsType: string;
        createdBy: string;
        updatedBy: string;
        createdDate: string;
        updatedDate: string;
    }

    //Function to fetch insights
    const fetchInsights = async (selectedMonth: string) => {
        setLoader(true);
        try {
            const response = await getInsights('MBT', '', selectedMonth);
            if (response.success) {
                setInsights(response.data.data);
                setLoader(false);
                console.log('response', response);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.error('Failed to get insights:', error);
        }
    };

    // Fetch insights
    useEffect(() => {
        fetchInsights(filterMonth);
    }, []);

    // Function to handle adding a new insight
    const handleAddInsight = async (newInsight: any) => {
        try {
            setLoader(true);
            const response = await addOrUpdateInsights({
                title: newInsight?.title,
                xopsType: 'MBT',
                description: newInsight?.description
            });
            if (response.success) {
                console.log('response', response);
                fetchInsights(filterMonth);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.error('Failed to add insight:', error);
        }
    };

    // Function to handle updating an insight
    const handleUpdateInsight = async (updatedInsight: any) => {
        try {
            setLoader(true);
            const response = await addOrUpdateInsights({
                title: updatedInsight?.title,
                xopsType: 'MBT',
                description: updatedInsight?.description,
                insight_id: updatedInsight?.id
            });
            if (response.success) {
                console.log('response', response);
                fetchInsights(filterMonth);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.error('Failed to update insight:', error);
        }
    };

    // Function to handle deleting an insight
    const handleDeleteInsight = async (insightId: number) => {
        try {
            setLoader(true);
            const response = await deleteInsights(insightId);
            if (response.success) {
                console.log('response', response);
                fetchInsights(filterMonth);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.error('Failed to delete insight:', error);
        }
    };

    const handleDateChange = (selectedDate: string) => {
        fetchInsights(selectedDate);
    };
    

    return (
        <Box bgcolor="blue.darker" mt={0}>
            <PageHeader title="MBT Insights" stickyTop={78}>
            <YearMonthPicker 
                    customMonth={customMonth}
                    filterMonth={filterMonth}
                    setCustomMonth={setCustomMonth}
                    setFilterMonth={setFilterMonth}
                    handleChange={handleDateChange}
                />
            {/* <DateFilterDropdown
                    customMonth={customMonth}
                    filterMonth={filterMonth}
                    setCustomMonth={setCustomMonth}
                    setFilterMonth={setFilterMonth}
                    handleChange={handleDateChange}
                    isXOps={true}
                /> */}
            </PageHeader>
            
            {<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <iframe 
                    src="https://app.powerbi.com/reportEmbed?reportId=a4a91812-8ae2-497c-9a29-2a0deeb8ae22&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&actionBarEnabled=true&reportCopilotInEmbed=true"
                    width="75%" height="700px">
                </iframe>
            </Box>}
            
            <Box marginTop={4} px={{ xs: 1, md: 2, lg: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{ color: '#009BDB', fontSize: '16px', fontWeight: 600 }}>Insights/Actions</Typography>
                    <Divider sx={{ flexGrow: 1, backgroundColor: '#009BDB', marginLeft: 2 }} />
                </Box>
                <Typography
                    variant="body2"
                    sx={{ fontStyle: 'italic', color: '#71758F', fontSize: '14px', fontWeight: '500', marginBottom: 5 }}
                >
                    You can display and update Insights/Actions if any.
                </Typography>
            </Box>
            {loader ? (
                <LoaderComponent />
            ) : (
                <Box sx={{ mb: 3, px: { xs: 1, md: 2, lg: 3 } }}>
                    <Insights
                        insights={insights}
                        setInsights={setInsights}
                        onAdd={handleAddInsight}
                        onUpdate={handleUpdateInsight}
                        onDelete={handleDeleteInsight}
                    />
                </Box>
            )}
        </Box>
    );
};
export default MBTDashboard;
